import React from "react";
import { ReactComponent as NoTokensIcon } from "../../../../img/no-tokens.svg";

export interface NoTokenMatchesProps {
  isVisible?: boolean;
}

export const NoTokenMatches: React.FC<NoTokenMatchesProps> = ({ isVisible = true }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div className="d-flex flex-column h-100 justify-content-center align-items-center">
      <NoTokensIcon />
      <p className="mt-2" style={{ color: "#F1F3F3", fontSize: "14px" }}>
        Hmmm we can’t find that token...
      </p>
    </div>
  );
};
